import React from 'react';
import { Card, CardContent, Chip, CircularProgress, Grid, IconButton, ListItemIcon, ListItemText, MenuItem, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import config from 'src/config';
import Swal from 'sweetalert2';
import { getFileAuditLogs } from 'src/services/file.service';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import moment from 'moment';
import { actionsMap } from './data';
import { formatDate } from 'src/methods/common.methods';
import VisibilityIcon from '@mui/icons-material/Visibility';

// ----------------------------------------------------------------------



class FileAuditLogModal extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			view_type: this.props.view_type || 'menu',
			is_modal_open: false,
			loading: false,

			file_audit_logs: [],
		}
	}

	async fetchFileAuditLogs() {

		const file_audit_logs = await getFileAuditLogs(this.props.file._id);
		if (!file_audit_logs) {
			return;
		}
		if (file_audit_logs.error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: file_audit_logs.error,
				confirmButtonText: 'Ok',
				confirmButtonColor: config.primaryColor
			});
			return;
		}

		await this.setState({
			file_audit_logs: file_audit_logs.file_audit_logs || [],
			loading: false
		});

	}
		

	FileAuditLogTable = () => {

		if (this.state.file_audit_logs.length === 0) {
			return (
				<Typography variant="h6" align="center" sx={{ opacity: 0.6 }}>
					No audit logs found for this file.
				</Typography>
			);
		}

		return (
			<TableContainer component={Paper}>
				<Table sx={{ width: '100%' }} aria-label="audit log table">
					<TableHead>
						<TableRow>
							<TableCell>User</TableCell>
							<TableCell>Action</TableCell>
							<TableCell>Timestamp</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{this.state.file_audit_logs.map((audit_log) => (
							<TableRow
								key={audit_log._id}
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
								<TableCell component="th" scope="row">
									{audit_log.user.username}
								</TableCell>
								<TableCell>{actionsMap[audit_log.action]}</TableCell>
								<TableCell>{formatDate(audit_log.created_at)}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		);
	}

	render() {
		return (
			<>
			{(this.state.view_type == 'menu') ? (
				<MenuItem
					onClick={() => {
						this.setState({
							is_modal_open: true,
							loading: true
						});
						this.fetchFileAuditLogs();
					}}
				>
					<ListItemIcon>
						<FeaturedPlayListIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>
						View Audit Log
					</ListItemText>
				</MenuItem>
			) : null}
			{(this.state.view_type == 'icon') ? (
				<IconButton
					onClick={() => {
						this.setState({
							is_modal_open: true,
							loading: true
						});
						this.fetchFileAuditLogs();
					}}
					size='small'
				>
					<FeaturedPlayListIcon />
				</IconButton>
			) : null}
			{(this.state.view_type == 'chip') ? (
				<Chip
					variant="outlined"
					icon={<VisibilityIcon />}
					label="Audit Log"
					size="small"
					onClick={() => {
						this.setState({
							is_modal_open: true,
							loading: true
						});
						this.fetchFileAuditLogs();
					}}
				/>
			) : null}
			<Modal
				open={this.state.is_modal_open}
				onClose={() => {
					if (this.props.onClose) {
						this.props.onClose();
					}
					this.setState({
						is_modal_open: false
					});
				}}
			>
				<Grid container>
					<Grid item style={modalStyle} xs={12} md={8} lg={6}>
						<Card variant='outlined'>
							<CardContent style={{ padding: 20 }}>
								{(this.state.loading) ? (
									<CircularProgress />
								) : null}
								{(!this.state.loading) ? (
									this.FileAuditLogTable()
								) : null}
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Modal>
			</>
		);
	}
}

const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '100%',
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 2,
	maxHeight: '90%',
	overflowY: 'auto'
};

export default function (props) {
	return <FileAuditLogModal {...props} />;
}
